import React from 'react';
import MDEditor from '@uiw/react-md-editor';
function MarkdownEditorComponent({ description, setDescription }) {
  const handleEditorChange = (value) => {
    setDescription(value);
  };

  return (
    <div>
      <div data-color-mode="light">
        <div className="wmde-markdown-var"> </div>
        <MDEditor
          placeholder={'Description'}
          value={description}
          preview="edit"
          onChange={(value) => {
            handleEditorChange(value);
          }}
        />
      </div>
    </div>
  );
}

export default MarkdownEditorComponent;
